import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/img-cms/icon/home_active@2x.png';
import _imports_1 from '@/assets/img-cms/icon/home@2x.png';
import _imports_2 from '@/assets/img-cms/icon/institutions_active@2x.png';
import _imports_3 from '@/assets/img-cms/icon/institutions@2x.png';
import _imports_4 from '@/assets/img-cms/icon/user_active@2x.png';
import _imports_5 from '@/assets/img-cms/icon/user@2x.png';
import _imports_6 from '@/assets/img-cms/icon/account_active@2x.png';
import _imports_7 from '@/assets/img-cms/icon/account@2x.png';
import _imports_8 from '@/assets/img-cms/icon/document@2x.png';
import _imports_9 from '@/assets/img-cms/icon/open_document@2x.png';
const _withScopeId = n => (_pushScopeId("data-v-19a9f9f3"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "icon",
  src: _imports_0
};
const _hoisted_2 = {
  key: 1,
  class: "icon",
  src: _imports_1
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "首页", -1));
const _hoisted_4 = {
  key: 0,
  class: "icon",
  src: _imports_2
};
const _hoisted_5 = {
  key: 1,
  class: "icon",
  src: _imports_3
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "机构管理", -1));
const _hoisted_7 = {
  key: 0,
  class: "icon",
  src: _imports_4
};
const _hoisted_8 = {
  key: 1,
  class: "icon",
  src: _imports_5
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "授权用户管理", -1));
const _hoisted_10 = {
  key: 0,
  class: "icon",
  src: _imports_6
};
const _hoisted_11 = {
  key: 1,
  class: "icon",
  src: _imports_7
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "账号管理", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "操作日志", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "使用配额", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "icon",
  src: _imports_8
}, null, -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开发与操作帮助文档", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "open_icon",
  src: _imports_9
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_menu_item = _resolveComponent("el-menu-item");
  const _component_el_sub_menu = _resolveComponent("el-sub-menu");
  const _component_el_menu = _resolveComponent("el-menu");
  return _openBlock(), _createBlock(_component_el_menu, {
    class: "el-menu-vertical-demo",
    "default-active": _ctx.defaultActive,
    onOpen: _ctx.select,
    onSelect: _ctx.select,
    router: ""
  }, {
    default: _withCtx(() => [_createVNode(_component_el_menu_item, {
      index: "home"
    }, {
      default: _withCtx(() => [_ctx.homeActive ? (_openBlock(), _createElementBlock("img", _hoisted_1)) : _createCommentVNode("", true), !_ctx.homeActive ? (_openBlock(), _createElementBlock("img", _hoisted_2)) : _createCommentVNode("", true), _hoisted_3]),
      _: 1
    }), _createVNode(_component_el_menu_item, {
      index: "institutions"
    }, {
      default: _withCtx(() => [_ctx.institutionActive ? (_openBlock(), _createElementBlock("img", _hoisted_4)) : _createCommentVNode("", true), !_ctx.institutionActive ? (_openBlock(), _createElementBlock("img", _hoisted_5)) : _createCommentVNode("", true), _hoisted_6]),
      _: 1
    }), _createVNode(_component_el_menu_item, {
      index: "authorization-user"
    }, {
      default: _withCtx(() => [_ctx.authorizationUserActive ? (_openBlock(), _createElementBlock("img", _hoisted_7)) : _createCommentVNode("", true), !_ctx.authorizationUserActive ? (_openBlock(), _createElementBlock("img", _hoisted_8)) : _createCommentVNode("", true), _hoisted_9]),
      _: 1
    }), _createVNode(_component_el_sub_menu, {
      index: "account"
    }, {
      title: _withCtx(() => [_ctx.accountActive ? (_openBlock(), _createElementBlock("img", _hoisted_10)) : _createCommentVNode("", true), !_ctx.accountActive ? (_openBlock(), _createElementBlock("img", _hoisted_11)) : _createCommentVNode("", true), _createElementVNode("span", {
        class: _normalizeClass({
          account_active: _ctx.accountActive
        })
      }, "账户", 2)]),
      default: _withCtx(() => [_createVNode(_component_el_menu_item, {
        index: "account-manage"
      }, {
        default: _withCtx(() => [_hoisted_12]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "account-log"
      }, {
        default: _withCtx(() => [_hoisted_13]),
        _: 1
      }), _createVNode(_component_el_menu_item, {
        index: "order-list"
      }, {
        default: _withCtx(() => [_hoisted_14]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_menu_item, {
      index: "/"
    }, {
      default: _withCtx(() => [_hoisted_15, _hoisted_16, _hoisted_17]),
      _: 1
    })]),
    _: 1
  }, 8, ["default-active", "onOpen", "onSelect"]);
}